import { analyticsEventTypes } from 'events/analytics';
import { QUICK_ACTION_SELECTED, QUICK_ACTION_TYPE } from 'GladlySidekickConstants';

export default function quickActionSelected() {
  return {
    [analyticsEventTypes.QUICK_ACTION_SELECTED]: ({ payload: { label, entityType } }) => {
      return [
        {
          eventName: QUICK_ACTION_SELECTED,
          eventPayload: [
            {
              label,
              type: mapQuickActionEntityType(entityType),
            },
          ],
        },
      ];
    },
  };
}

function mapQuickActionEntityType(entityType) {
  switch (entityType) {
    case 'answer':
      return QUICK_ACTION_TYPE.ANSWER;
    case 'externalLink':
      return QUICK_ACTION_TYPE.EXTERNAL_LINK;
  }

  return '';
}
